const moreBookingsCarousel = require('../components/moreBookingsCarousel').moreBookingsCarousel;

new moreBookingsCarousel();